/** 亚马逊站点 */
export const AMAZON_SITES = [
    { code: 'US', name: 'United States', language: 'English' },
    { code: 'UK', name: 'United Kingdom', language: 'British English' },
    { code: 'DE', name: 'Germany', language: 'German' },
    { code: 'FR', name: 'France', language: 'French' },
    { code: 'ES', name: 'Spain', language: 'Spanish' },
    { code: 'IT', name: 'Italy', language: 'Italian' },
    { code: 'JP', name: 'Japan', language: 'Japanese' },
    { code: 'CA', name: 'Canada', language: 'English' },
    { code: 'MX', name: 'Mexico', language: 'Spanish' },
] as const;

export type AmazonSiteCode = typeof AMAZON_SITES[number]['code'];
